import { render, staticRenderFns } from "./the-side-bar.vue?vue&type=template&id=4a8ea94a&"
import script from "./the-side-bar.vue?vue&type=script&lang=js&"
export * from "./the-side-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports